import {
  createClientDropdown,
  createGroupTypeDropdown,
  HEALTH_PLAN_DROPDOWN,
  PLAN_TYPE_DROPDOWN,
  sortFilterDropdowns,
} from 'constants/filterConfigs';
import {
  END_DATE,
  HEALTH_PLAN_CLASSIFICATION,
  PLAN_TYPE_CLASSIFICATION,
  START_DATE,
} from 'constants/filterKeysConstants';
import GroupType from 'models/GroupType';

export const receivingGroupFilterKey = (groupType: GroupType) => groupType.camelCaseApiName;
export const receivingClientFilterKey = (groupType: GroupType) => `${groupType.camelCaseApiName}Client`;

export const filtersForGroupType = (
  filters: Record<string, any>,
  selectedGroupType: GroupType,
  predecessorFilterKey: string
): Record<string, any> => {
  const validKeys = [
    predecessorFilterKey,
    receivingClientFilterKey(selectedGroupType),
    receivingGroupFilterKey(selectedGroupType),
    HEALTH_PLAN_CLASSIFICATION,
    PLAN_TYPE_CLASSIFICATION,
    START_DATE,
    END_DATE,
  ];

  return Object.entries(filters).reduce(
    (acc, [key, val]) => (validKeys.includes(key) ? { ...acc, [key]: val } : acc),
    {} as Record<string, any>
  );
};

export const getFilterSections = (
  predecessorGroupType: GroupType | undefined,
  selectedGroupType: GroupType | undefined,
  predecessorFilterKey: string
) => {
  if (!predecessorGroupType || !selectedGroupType) return [];

  const groupTypeName = selectedGroupType.displayName;

  const predecessorGroupDropdown = createGroupTypeDropdown(predecessorGroupType, undefined, {
    placeholder: `Referring ${predecessorGroupType.displayName}`,
    name: predecessorFilterKey,
  });

  const providerClientDropdown = createClientDropdown(
    [selectedGroupType.id],
    `${groupTypeName} Company`,
    receivingClientFilterKey(selectedGroupType),
    { groupTypeType: 'provider' }
  );

  const groupDropdown = createGroupTypeDropdown(selectedGroupType, undefined, {
    placeholder: groupTypeName,
    name: receivingGroupFilterKey(selectedGroupType),
  });

  return [
    {
      filters: sortFilterDropdowns([
        predecessorGroupDropdown,
        providerClientDropdown,
        groupDropdown,
        HEALTH_PLAN_DROPDOWN,
        PLAN_TYPE_DROPDOWN,
      ]),
    },
  ];
};
